import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../shared/capsFetcher';

const useAdvisors = (dealershipId) => useSWRImmutable(dealershipId ? `/dealerships/${dealershipId}/service_managers` : null, (url) => capsFetcher({ url }));

export default useAdvisors;
